export default "__VITE_ASSET__D2J3Y418__"